import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import axios from "axios";
import "../../assests/css/students/eventpage/eventhero.css";
import { AppContext } from "../../context/Appcontext";

function EventHero() {

  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [events, setEvents] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    viewAllEvents();
  }, []);

  const viewAllEvents = () => {
    axios
      .get(`${baseUrl}/admin/events/viewAllEvents`)
      .then((response) => {
        setEvents(response.data.events || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (events.length === 0) {
    return (
      <section className="eh-hero-section">
        <Container>
          <h3 style={{ textAlign: "center", padding: "80px 0" }}>
            No Event Found
          </h3>
        </Container>
      </section>
    );
  }

  // Only keep events that actually have a hero_image (avoid empty slides)
  const eventsWithImages = events.filter((ev) => ev?.hero_image);

  // Text on the left changes along with the active carousel slide
  const activeEvent = eventsWithImages[activeIndex] || events[0];

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <section className="eh-hero-section">

      <Container>

        <Row className="align-items-center eh-hero-row">

          {/* LEFT SIDE */}

          <Col lg={6} md={12} className="eh-text-col">

            <h1 className="eh-heading">
              {activeEvent.hero_title}
            </h1>

            <p className="eh-description">
              {activeEvent.hero_subtitle}
            </p>

          </Col>

          {/* RIGHT SIDE */}

          <Col lg={6} md={12} className="eh-carousel-col">

            <div className="eh-carousel-wrapper">

              <Carousel
                fade
                controls
                indicators
                interval={3000}
                activeIndex={activeIndex}
                onSelect={handleSelect}
              >

                {eventsWithImages.map((event) => (
                  <Carousel.Item key={event.id}>

                    <img
                      className="eh-carousel-img"
                      src={`${baseUrlForFiles}/${event.hero_image}`}
                      alt={event.hero_title}
                    />

                  </Carousel.Item>
                ))}

              </Carousel>

            </div>

          </Col>

        </Row>

      </Container>

    </section>
  );
}

export default EventHero;